/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it
import "./src/styles/reset.css";
import "./src/styles/global.css";


export const onRouteUpdate = () => {
    document.body.classList.remove('noscroll');
}
